import xhrCaller from "./xhr-caller";

export const xhrInstGetInstitutionsByTenantId = async (token, id) => {
	var result = await xhrCaller({
		bearer: token,
		srv: "api",
		action: `Institution/GetInstitutionsByTenantId?tenId=${id}`,
	});
	return result;
};

export const xhrInstGetInstitutionAll = async (token, page, perPage) => {
	var result = await xhrCaller({
		bearer: token,
		srv: "api",
		action: `Institution/GetInstitutionAll?pi=${page ?? 0}&pr=${
			perPage ?? 200
		}`,
	});
	return result;
};

export const xhrInstGetInstitutionById = async (token, id) => {
	var result = await xhrCaller({
		bearer: token,
		srv: "api",
		action: `Institution/GetInstitutionById?id=${id}`,
	});
	return result;
};

export const xhrInstGetEquipmentsAll = async (token, data) => {
	var result = await xhrCaller({
		bearer: token,
		srv: "api",
		data,
		action: `Institution/GetEquipmentAll`,
	});
	return result;
};
